<div class="modal-container">
  <button class="close-button" (click)="closeModal()" aria-label="Close modal">
    <app-icon-close color="#011835"></app-icon-close>
  </button>

  @if (
    data === 'UNSECURED_LOAN' ||
    data === 'UNSECURED_REFINANCE_LOAN' ||
    data === 'SECURED_HOME_LOAN' ||
    data === 'SECURED_HOME_REFINANCE_LOAN'
  ) {
    <div>
      <h2 mat-dialog-title class="heading">Full Disclosure</h2>
      @if (data === 'UNSECURED_LOAN' || data === 'UNSECURED_REFINANCE_LOAN') {
        @for (item of loanDisclosureText; track item) {
          <p class="modal-text" [innerHTML]="item"></p>
        }
      }
      @if (data === 'SECURED_HOME_LOAN' || data === 'SECURED_HOME_REFINANCE_LOAN') {
        @for (item of hslDisclosureText; track item) {
          <p class="modal-text" [innerHTML]="item"></p>
        }
      }
    </div>
  }
  @if (data === 'CREDIT_CARD') {
    <div>
      <p mat-dialog-title class="card-font bold center">TERMS & CONDITIONS FOR BEST EGG VISA ACCOUNTS® DISCLOSURE SUMMARY Rates and Fees Table</p>
      <p class="card-font">
        The Disclosure Summary shows a table of application rates and fees as of
        August 24, 2023. All terms, including fees and APRs for new
        transactions, are not guaranteed and may change in accordance with the
        Cardmember Agreement and applicable law based on information in your
        credit report, market conditions, business strategies, or for any other
        reason. Please review these terms so you are fully informed about this
        credit card offer.
      </p>
      @if (interestRatesObj) {
        <app-card-disclosure-table
          [cardDisclosures]="interestRatesObj"
        ></app-card-disclosure-table>
      }
      @if (feesObj) {
        <app-card-disclosure-table
          [cardDisclosures]="feesObj"
        ></app-card-disclosure-table>
      }
      <div>
        <p class="card-font">
          <span class="bold card-font">How we calculate your balance: </span>We
          use a method called Average Daily Balance (including new purchases).
        </p>
        <p class="card-font">
          <span class="bold card-font">Loss of Intro APR: </span>We will end
          your introductory APR if you do not make your required payment by the
          due date as reflected on your monthly billing statement and will apply
          the standard APR for your purchases
        </p>
        <p><span class="bold card-font">Minimum Credit Line </span>$500</p>
        <p class="card-font">
          <span class="bold card-font">Rewards: </span>Best Egg may offer
          rewards or other incentives from time to time to new Best Egg
          cardmembers in connection with an application for a new account and to
          existing Best Egg cardmembers. You will find out more about these
          rewards or other incentive offers and any other terms at the time of
          the offer.
        </p>
        <p class="bold card-font">Important Offer Details:</p>
        <p class="card-font">
          Offer subject to credit approval. If approved, Best Egg Credit Card is
          going to generate a hard credit pull which may impact your credit
          score. There will be no impact to your credit score if you are not
          approved.
        </p>
        <p class="card-font">
          To help the government fight the funding of terrorism and money
          laundering activities, Federal law requires all financial institutions
          to obtain, verify, and record information that identifies each person
          who opens an account. What this means for you: When you open an
          account, we will ask for your name, address, date of birth, and other
          information that will allow us to identify you. We may also ask to see
          your driver’s license or other identifying documents.
        </p>
        <p class="card-font">
          Best Egg loans are personal loans made by Cross River Bank, a New
          Jersey Chartered Bank, operating from its Wilmington, Delaware branch
          location, Member FDIC, Equal Housing Lender, or Column N.A., Member
          FDIC, Equal Housing Lender. The Best Egg Secured Loan is originated
          exclusively by Cross River Bank.
        </p>
        <p class="bold underline card-font">Rewards Terms and Conditions</p>
        <p class="bold card-font">Best Egg Rewards 1% on Purchases</p>
        <p class="card-font">
          This document contains important terms and conditions (“Reward Rules”)
          for the rewards program (“Program”) for the Best Egg Visa® Credit Card
          Cash Rewards account (“Account”) issued by First Bank & Trust,
          Brookings, SD, pursuant to a license by Visa International. You agree
          that use of your Account or a feature of the Program by you or an
          Authorized User constitutes your acceptance of each of the terms of
          the Reward Rules. “You”, “your” or “primary cardmember” means the
          person who applied for the Account. Capitalized terms not defined in
          these Reward Rules have the meaning ascribed to them in the Cardmember
          Agreement associated with your Account linked to this Program.
        </p>
        <p class="card-font">
          he Privacy Policy for Best Egg is available online at
          bestegg.com/privacy-policy/.
        </p>
        <p class="bold card-font">Administration and Participation</p>
        <p class="card-font">
          The Program and Reward Rules are administered by Best Egg located in
          Wilmington, DE in its sole discretion. We reserve the right to modify,
          amend or terminate the Reward Rules and the Program at any time with
          or without notice.
        </p>
        <p class="card-font">
          To maintain your eligibility for participation in the Program through
          use of the Account:
        </p>
        <ul>
          <li class="card-font">
            You must maintain an open Account that is in “good standing” which
            means Account is not in default as described in your Cardmember
            Agreement with us (in “Good Standing”).
          </li>
          <li class="card-font">
            You must be an individual (not a corporation, partnership, or other
            entity) and the Account may only be used for personal, family or
            household expenses.
          </li>
        </ul>
        <p class="bold card-font">General Information</p>
        <ul>
          <li class="card-font">
            As long as the Program continues and the Account is open and in Good
            Standing, there is no limit to the total rewards you can earn and
            your rewards will not expire.
          </li>
          <li class="card-font">
            You may not earn or redeem rewards during any period in which your
            Account is past due.
          </li>
          <li class="card-font">
            If you have a rewards balance on your account that meets the minimum
            redemption requirement(s), you will have 90 days from the Account
            closure date to redeem any outstanding rewards, as long as your
            Account at the time of closure was not closed for any reasons
            outlined in the
            <span class="bold">Rewards Forfeiture Section</span>
          </li>
          <li class="card-font">
            All rewards earned by the primary cardmember and any authorized
            user(s) will be added to the primary cardmember’s rewards balance.
          </li>
          <li class="card-font">
            If you have questions about rewards, please contact the Customer
            Service number on the back of your card.
          </li>
          <li class="card-font">
            You have no property rights or other legal interest in rewards.
            Rewards may not be transferred or assigned.
          </li>
          <li class="card-font">
            Participation in the Program through use of your Account is subject
            to all applicable laws and regulations. The sale or barter of any
            rewards offered through the Program earned through use of the
            Account, other than by us, is expressly prohibited. There could be
            tax implications for rewards earned and/or redeemed. Please consult
            your tax advisor if you have tax questions about the Program. Best
            Egg does not provide tax advice.
          </li>
          <li class="card-font">
            You can view a summary of your rewards earned through the use of
            your Account on your monthly Account billing statement or by logging
            into bestegg.com.
          </li>
          <li class="card-font">
            Best Egg reserves the right to correct inaccurate rewards values
            represented on statements, our website and/or our mobile app, at our
            sole discretion. Best Egg is not responsible for typographical
            errors or omissions in this document, website, mobile app, or any
            marketing materials.
          </li>
          <li class="card-font">
            Best Egg reserves the right in its sole discretion to cancel,
            modify, restrict or terminate the Program or any aspects or features
            of the Program at any time without prior notice.
          </li>
          <li class="card-font">
            Best Egg may supplement these Reward Rules with additional terms,
            conditions, disclosures and agreements that will be considered part
            of this agreement.
          </li>
          <li class="card-font">
            Rewards cannot be combined with other discount or reward programs
            unless specifically authorized by Best Egg.
          </li>
          <li class="card-font">
            All interpretations of the Reward Rules shall be at our sole
            discretion. Other significant terms may apply. All trademarks and
            service marks belong to their respective owners.
          </li>
        </ul>
        <p class="card-font bold">Earning Rewards</p>
        <p class="card-font">
          You earn cash back rewards for purchases minus credits, returns and
          other adjustments (“Purchases”) made by you and/or any authorized
          user(s) of the Account as follows:
        </p>
        <ul>
          <li class="card-font">
            You earn one percent (1%) in cash back rewards for every one dollar
            ($1) spent on all Purchases. For example, if you spend $100 in
            Purchases you will be awarded one dollar ($1) in rewards.
          </li>
          <li class="card-font">
            In order to receive the rewards for the Purchases, the merchant must
            submit the Purchase using the appropriate merchant category codes.
            Rewards may not be earned if the merchant submits the Purchase using
            a mobile or wireless card reader or if you use a mobile or digital
            wallet to pay for the Purchases. Additionally, Purchases made
            through third parties, including online marketplaces and resellers,
            or using a third-party payment account will not earn additional
            rewards. Best Egg is not responsible for incorrectly coded
            purchases. For questions regarding transaction processing for
            Purchases, please reach out to the merchant.
          </li>
          <li class="card-font">
            Balance transfers, cash advances (including cash equivalent
            transactions such as, but not limited to, the use of your Account to
            obtain money orders, traveler’s checks, foreign currency and lottery
            tickets), fees, interest charges and unauthorized/fraudulent
            purchases are not considered Purchases and do not earn rewards.
          </li>
        </ul>
        <p class="card-font bold">Bonus Rewards</p>
        <p class="card-font">
          Best Egg may offer bonus rewards or other incentives to new Best Egg
          cardmembers in connection with an application for a new account. These
          bonuses and/or incentives are intended for applicants who are not and
          have not previously been Best Egg cardmembers. You understand and
          agree that you may no longer be eligible for any bonuses and/or
          incentives in connection with a new Best Egg account after this
          Account is opened. If you receive a bonus or incentive for which you
          are not eligible due to your status as a current or former Best Egg
          cardmember, we may revoke the bonus or incentive, or reduce your
          rewards by the amount of the bonus or incentive, or charge your
          Account for the fair value of the bonus or incentive, in our sole
          discretion.
        </p>
        <p class="card-font">
          Best Egg may offer you other ways to earn bonus rewards or other
          incentives through the Program. You will find out more about these
          bonus rewards offers and any other terms at the time of the offer. The
          additional terms will be part of this agreement.
        </p>
        <p class="card-font bold">Reedeming Rewards</p>
        <p class="card-font">
          You have the option to redeem your rewards for statement credits or
          for rewards using the “Pay Me Back” program as described below. To
          redeem your rewards, call the number on the back of your card or log
          into your Account at bestegg.com. Best Egg is not responsible for
          unauthorized redemptions on your Account. All redemptions are final.
        </p>
        <p class="card-font bold">Statement Credits</p>
        <ul>
          <li class="card-font">
            You may request a statement credit when you have accumulated $20.00
            in rewards. You must have at least $20.00 in rewards to apply as a
            statement credit.
          </li>
          <li class="card-font">
            The credit will be posted to your Account within 3-5 business days
            and will appear on your Account billing statement within one (1)
            billing cycle.
          </li>
          <li class="card-font">
            Statement credits reduce your Account balance but you are still
            required to pay your minimum payment or remaining statement balance,
            whichever is less, by the payment due date and are otherwise subject
            to the terms and conditions applicable to your Account.
          </li>
        </ul>
        <p class="card-font bold">Pay Me Back</p>
        <ul>
          <li class="card-font">
            You may redeem rewards for a credit to your credit card account to
            reimburse yourself for specific Purchase(s) that were made in the
            last 90 days.
          </li>
          <li class="card-font">
            You may select up to 3 Purchase transactions per redemption which
            cannot exceed your current rewards balance.
          </li>
          <li class="card-font">
            The Purchase(s) transaction amount to be redeemed may not exceed the
            total amount available for redemption.
          </li>
          <li class="card-font">
            A minimum of $20.00 in Purchase(s) must be selected.
          </li>
        </ul>
        <p class="card-font bold">Rewards Forfeiture</p>
        <p class="card-font">
          If your Account is closed for any of the following reasons, any
          rewards you have earned will be forfeited:
        </p>
        <ul>
          <li class="card-font">
            You or any authorized user(s) on the Account engages in any
            fraudulent or illegal activity through the use of your Account.
          </li>
          <li class="card-font">
            You, or any authorized user(s) on the Account engage in any activity
            that is deemed to be abusive or gaming conduct, as determined by us
            in our sole discretion. Abusive or gaming activity includes, but is
            not limited to, obtaining or using an account to maximize rewards
            earned in a manner that is not consistent with typical consumer
            activity and/or multiple credit card account applications/openings,
            as determined by us in our sole discretion.
          </li>
          <li class="card-font">Your history of Account usage</li>
          <li class="card-font">
            Your Account is delinquent, as determined by Best Egg in its sole
            discretion
          </li>
          <li class="card-font">
            Your Account is otherwise in default under your Cardmember Agreement
            with us.
          </li>
        </ul>
        <p class="card-font">
          ©2023 Marlette Marketing, LLC. All rights reserved.
        </p>
      </div>
    </div>
  }
</div>
